import { format } from "date-fns";
import { map } from "lodash";
import {
  RequestOverviwOfferList,
  ResultsOffer,
  Product,
  CreateOfferData,
  Offer,
  OfferProducts,
  OfferDetails,
} from "../types/offers";
import api from "./api";

export const listOverviewOffers = async (
  startDate: Date,
  endDate: Date,
  storeId = 0,
  offerName
): Promise<RequestOverviwOfferList> => {
  const params = {
    status: 1,
    complete: 1,
    dataInicio: format(startDate, "yyyy-MM-dd"),
    dataFim: format(endDate, "yyyy-MM-dd"),
    idLoja: storeId,
    nomeOferta: offerName,
  };
  const response = await api.get(
    "oferta-p2-:stage/:stage/crm/produto/getPerformanceOfertas",
    { params }
  );

  return { ...response.data, visaoGeral: response.data?.visaoGeral[0] };
};

export const listOverviewOffersDay = async (
  startDate: Date,
  endDate: Date,
  storeId = 0,
  offerName
): Promise<any[]> => {
  const params = {
    status: 1,
    complete: 1,
    dataInicio: format(startDate, "yyyy-MM-dd"),
    dataFim: format(endDate, "yyyy-MM-dd"),
    idLoja: storeId,
    nomeOferta: offerName,
  };
  const response = await api.get(
    "oferta-p2-:stage/:stage/crm/produto/getVendasOfertaDia",
    { params }
  );

  return response.data.vendasDia;
};

export const listOverviewOffersHour = async (
  startDate: Date,
  endDate: Date,
  storeId = 0,
  offerName
): Promise<any[]> => {
  const params = {
    status: 1,
    complete: 1,
    dataInicio: format(startDate, "yyyy-MM-dd"),
    dataFim: format(endDate, "yyyy-MM-dd"),
    idLoja: storeId,
    nomeOferta: offerName,
  };
  const response = await api.get(
    "oferta-p2-:stage/:stage/crm/produto/getVendasOfertaHora",
    { params }
  );

  return response.data.vendasHora;
};

export const listOverviewOffersStore = async (
  startDate: Date,
  endDate: Date,
  storeId = 0,
  offerName
): Promise<any[]> => {
  const params = {
    status: 1,
    complete: 1,
    dataInicio: format(startDate, "yyyy-MM-dd"),
    dataFim: format(endDate, "yyyy-MM-dd"),
    idLoja: storeId,
    nomeOferta: offerName,
  };
  const response = await api.get(
    "oferta-p2-:stage/:stage/crm/produto/getVendasOfertaLoja",
    { params }
  );

  return response.data.vendasLoja;
};

export const listOffers = async (
  startDate: Date,
  endDate: Date,
  storeId = 0,
  offerName
): Promise<Offer[]> => {
  const params = {
    dataInicio: format(startDate, "yyyy-MM-dd"),
    dataFim: format(endDate, "yyyy-MM-dd"),
    idLoja: storeId,
    nomeOferta: offerName,
  };
  const response = await api.get("oferta-p2-:stage/:stage/crm/offer-v2", {
    params,
  });

  return response.data;
};

export const listResultsOffers = async (
  startDate: Date,
  endDate: Date,
  storeId = 0,
  offerName
): Promise<ResultsOffer[]> => {
  const params = {
    status: 1,
    complete: 1,
    dataInicio: format(startDate, "yyyy-MM-dd"),
    dataFim: format(endDate, "yyyy-MM-dd"),
    idLoja: storeId,
    nomeOferta: offerName,
  };
  const response = await api.get(
    "oferta-p2-:stage/:stage/crm/produto/getOfertasCompletas",
    {
      params,
    }
  );

  return response.data.completas;
};

export const listOfferProducts = async (
  offerId: number
): Promise<OfferProducts[]> => {
  const response = await api.get(
    "oferta-p2-:stage/:stage/crm/products-offer-v2",
    {
      params: { offerId },
    }
  );

  return response.data;
};

export const findProduct = async (ean, id): Promise<Product> => {
  const params = { ean, id };
  const response = await api.get("oferta-p2-:stage/:stage/crm/getProduto", {
    params,
  });

  return response.data[0];
};

export const findOfferDetails = async (id: number): Promise<OfferDetails> => {
  const params = { idOferta: id };
  const response = await api.get(
    "oferta-p1-:stage/:stage/crm/getDetalhesOferta",
    {
      params,
    }
  );

  return response.data;
};

export const newOffers = async (data: CreateOfferData): Promise<any> => {
  const createHeaderOffersData = {
    dataFim: format(data.endDate, "yyyy-MM-dd HH:mm:ss"),
    dataInicio: format(data.startDate, "yyyy-MM-dd HH:mm:ss"),
    idList: data.insight?.idListProspectei,
    lojas: map(data.stores, (store) => store.id_loja),
    nomeOferta: data.name,
    one2one: data.type === "one_to_one",
    tipoOferta: "desconto",
    documento: data.type === "one_to_one" ? data.clientOne2One.documento : null,
    id_pessoa: data.type === "one_to_one" ? data.clientOne2One.id_pessoa : null,
    nome_pessoa: data.type === "one_to_one" ? data.clientOne2One.nome : null,
    personalizada: data.type === "personalized",
    produtos: map(data.products, (product) => ({
      idProduto: product.id,
      nomeProduto: product.name,
      porcentagem: product.percentage,
      preco: product.price,
      precoDesconto: product.discount_price,
    })),
  };
  const response = await api.post(
    "oferta-p2-:stage/:stage/crm/offer-v2",
    createHeaderOffersData
  );

  return response.data;
};

export const putOffers = async (data: CreateOfferData) => {
  const updateHeaderOffersData = {
    id_oferta: data.offerId,
    dataFim: format(data.endDate, "yyyy-MM-dd HH:mm:ss"),
    dataInicio: format(data.startDate, "yyyy-MM-dd HH:mm:ss"),
    idList: data.insight?.idListProspectei,
    nomeOferta: data.name,
    one2one: data.type === "one_to_one",
    tipoOferta: "desconto",
    documento: data.type === "one_to_one" ? data.clientOne2One.documento : null,
    id_pessoa: data.type === "one_to_one" ? data.clientOne2One.id_pessoa : null,
    nome_pessoa: data.type === "one_to_one" ? data.clientOne2One.nome : null,
    personalizada: data.type === "personalized",
    produtos: map(data.products, (product) => ({
      idProduto: product.id,
      nomeProduto: product.name,
      porcentagem: product.percentage,
      preco: product.price,
      precoDesconto: product.discount_price,
    })),
  };
  const response = await api.put(
    "oferta-p2-:stage/:stage/crm/offer-v2",
    updateHeaderOffersData
  );

  return response.data;
};
